module.exports = __webpack_public_path__ + "img/category-card-bg-4.a21f6af4.png";